export const htmlParseOptions = {
    replace: (domNode: any) => {
        const tag = domNode.name?.toLowerCase();
        // Remove dangerous tags
        if (["script", "iframe", "object", "embed"].includes(tag)) {
            return <></>;
        }
        // Remove event-handler attributes
        if (domNode.attribs) {
            Object.keys(domNode.attribs).forEach(attr => {
                if (/^on/i.test(attr)) {
                    delete domNode.attribs[attr];
                }
            });
        }
        return domNode;
    },
};
